import { useCallback } from 'react';

import { useGetNotifications } from 'src/use-cases/notification/useNotification';
import { NotificationContent } from './Content';
import { useNotificationSelector } from './NotificationContext';
import { NotificationDetail } from './Detail';
import { useGetDomainMetaData } from '../../../../use-cases/invoice/useInvoices';
import { NotificationIndicator } from './NotificationIndicator';

export const Notification = ({ id }: { id?: string }) => {
  const { setIsShowContent, isShowContent } = useNotificationSelector();

  const { data: domainMetaData } = useGetDomainMetaData();

  // Only fetch notifications when dropdown is open
  const { data, isLoading, markAllAsRead } = useGetNotifications(isShowContent);
  const notifications = data?.notifications || [];

  const onClickNotifIcon = useCallback(() => {
    if (!isShowContent) {
      // Mark all as read when opening the dropdown
      markAllAsRead().catch((error) => {
        console.error('Failed to mark notifications as read:', error);
      });
    }
    setIsShowContent(!isShowContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isShowContent, setIsShowContent, markAllAsRead]);

  return (
    <>
      <NotificationIndicator onClick={onClickNotifIcon} isActive={isShowContent} id={id} />

      <NotificationContent allNotifications={notifications} isLoading={isLoading} />
      <NotificationDetail errorInvoiceFileProcessingStatuses={domainMetaData?.errorProcessingStatuses} />
    </>
  );
};
